import React from "react";
import "./renterInfoDisplay.css";
import DisplayHeading from "../displayHeading/displayHeading";
import ObjDisplay from "../objDisplay/objDisplay";
import { formatCustomerAddress, formatCustomerName } from "../../utils/utils";

function RenterInfoDisplay({ renterInfo, setStep }) {
  
  const formattedRenterInfo = {
    fullName: formatCustomerName(renterInfo, ""),
    email: renterInfo.email,
    phone: renterInfo.phone,
    address: formatCustomerAddress(renterInfo),
  };

  return (
    <div className="info-display-container main-border">
      <DisplayHeading
        buttonName={typeof(setStep) === "function" ? "Edit" : null}
        doSomething={() => setStep(1)}
        title={"Your Provided Details"}
      />

      <div className="container renter-info">
        <ObjDisplay data={formattedRenterInfo} />
      </div>
    </div>
  );
}

export default RenterInfoDisplay;
